import Tooltip from './TooltipWrapper';
export { Direction } from './types';

export default Tooltip;
